import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from 'vue-router'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

  const route = useRoute()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.layoutComponent), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _cache[0] || (_cache[0] = _createElementVNode("div", { id: "recaptcha-container" }, null, -1))
    ]),
    _: 3
  }))
}
}

})